import React, {FC, PropsWithChildren} from "react";
import "../Styles/DefaultLayout.css";
import {AppShell} from "./AppShell";
import {ShellBreadcrumbProvider} from "../Contexts/ShellBreadcrumbContext";

export const DefaultLayout: FC<PropsWithChildren> = ({children}) => {
    return <div className="default-layout">
        <ShellBreadcrumbProvider>
            <AppShell>
                {children}
            </AppShell>
        </ShellBreadcrumbProvider>
    </div>;
}
